import { render, staticRenderFns } from "./ChecklistComponent.vue?vue&type=template&id=c323ddd2&scoped=true&"
import script from "./ChecklistComponent.vue?vue&type=script&lang=js&"
export * from "./ChecklistComponent.vue?vue&type=script&lang=js&"
import style0 from "./ChecklistComponent.vue?vue&type=style&index=0&id=c323ddd2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c323ddd2",
  null
  
)

export default component.exports